"use client";

import {
  useCallback,
  useEffect,
  useRef,
  useState,
  type ReactNode,
} from "react";

import { useScrollProgress } from "./film-motion";

/** Rolls its children upward as the section scrolls through the viewport. */
export const CreditsRoll = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(!window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }, []);

  const onProgress = useCallback((progress: number) => {
    ref.current?.style.setProperty("--roll", String(progress));
  }, []);
  useScrollProgress(ref, onProgress, "through", enabled);

  return (
    <div ref={ref} className="film-credits-roll">
      {children}
    </div>
  );
};
